import {
  REQUEST_APP_INITIALIZER,
  APP_INITIALIZER_FAILURE,
} from '../constants/actionTypes';

export function reqAppInitializer(fieldId, mapLayerIds, seasonIds) {
  return {
    type: REQUEST_APP_INITIALIZER,
    fieldId,
    mapLayerIds,
    seasonIds,
  };
}

export function appInitializerFailure() {
  return {
    type: APP_INITIALIZER_FAILURE,
  };
}
